// extracted by mini-css-extract-plugin
export default {"detailsButton":"AssetDetailsButtons_detailsButton__o2p6i","cntbuttons":"AssetDetailsButtons_cntbuttons__vqUKb"};